import * as React from 'react';
import { PrimaryButton, Spinner, Stack } from '@fluentui/react';
import { AccountSelector } from '../../components/core/AccountSelector';
import { Account } from '../../api/accounts.types';
import { HealAPI } from '../../healApi';

export interface AddAgentFormProps {
  agencyId: string;
  onSuccess: () => void;
}

export interface AddAgentState {
  isSaving: boolean;
  agentId?: string;
}

export class AddAgentForm extends React.Component<AddAgentFormProps, AddAgentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSaving: false,
    };
  }

  public render(): JSX.Element {
    const { agentId, isSaving } = this.state;
    return (
      <Stack tokens={{ childrenGap: 16 }}>
        <AccountSelector onChange={this.onAccountChange} userAccountId={agentId} />
        <PrimaryButton onClick={this.addAgents} className="flex-end" style={{ marginTop: 20 }} text="Add" disabled={!this.canSubmit() || isSaving} />
        {isSaving && <Spinner />}
      </Stack>
    );
  }

  private onAccountChange = (account: Account) => {
    this.setState({ agentId: account.userAccountId });
  };

  private canSubmit(): boolean {
    return !!this.state.agentId;
  }

  private addAgents = () => {
    this.setState({ isSaving: true });
    HealAPI.addAgentToAgency(this.props.agencyId, [this.state.agentId!]).then((response) => {
      if (response.ok) {
        this.props.onSuccess();
      }
      this.setState({ isSaving: false });
    });
  };
}
